module.exports = __webpack_public_path__ + "img/sms.6c869dd3.png";